/**
 * Hero Collage — randomize the two side images on load.
 *
 * Each `.c-hero-collage` carries its full gallery as JSON in a child
 * `<script type="application/json" data-collage-gallery>`. The server renders the
 * first two images as the no-JS fallback; here we pick two distinct images at
 * random and swap them into the left/right slots so the hero varies on every
 * load — independent of full-page caching. The center video/image is never
 * touched.
 */

// Two distinct images from the pool (or the single image twice when there's one).
function pickTwo(pool) {
  if (pool.length <= 1) return [pool[0], pool[0]];
  const idx = pool.map((_, i) => i);
  for (let i = idx.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [idx[i], idx[j]] = [idx[j], idx[i]];
  }
  return [pool[idx[0]], pool[idx[1]]];
}

function applyImage(el, img) {
  // Only <img> slots hold a real image; placeholder divs (empty gallery) are left
  // untouched.
  if (!el || el.tagName !== 'IMG' || !img || !img.url) return;
  el.src = img.url;
  el.alt = img.alt || '';
}

function randomizeCollage(section) {
  const data = section.querySelector('script[data-collage-gallery]');
  let pool;
  try {
    pool = JSON.parse(data?.textContent || '[]');
  } catch {
    return;
  }
  if (!Array.isArray(pool) || pool.length === 0) return;

  const [left, right] = pickTwo(pool);
  applyImage(section.querySelector('[data-collage-slot="left"]'), left);
  applyImage(section.querySelector('[data-collage-slot="right"]'), right);
}

function init() {
  document.querySelectorAll('.c-hero-collage').forEach(randomizeCollage);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
